module.exports = __webpack_public_path__ + "media/dorobek/assets/images/DOI_logo-5ba24817858b90dc7816b6ed78f0d1cf.png";